import { CollectionType } from "@/pages/collectionDataSet/type";

export const naturalSort = (a: string, b: string) => {
  const extractParts = (str: string) =>
    str
      .match(/\d+|\D+/g)
      ?.map((part) => (/\d/.test(part) ? parseInt(part, 10) : part)) ?? [];

  const aParts = extractParts(a);
  const bParts = extractParts(b);

  for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
    if (aParts[i] === undefined) return -1;
    if (bParts[i] === undefined) return 1;

    if (aParts[i] !== bParts[i]) {
      if (typeof aParts[i] === "number" && typeof bParts[i] === "number") {
        return (aParts[i] as number) - (bParts[i] as number);
      }
      return String(aParts[i]).localeCompare(String(bParts[i]));
    }
  }
  return 0;
};

export const sortCollectedData = (
  filteredMachines: CollectionType[],
  sortConfig: {
    column: keyof CollectionType;
    direction: "asc" | "desc";
  }
) => {
  if (sortConfig.column) {
    return [...filteredMachines].sort((a, b) => {
      const aValue = a[sortConfig.column!];
      const bValue = b[sortConfig.column!];

      if (aValue === undefined || bValue === undefined) return 0;

      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortConfig.direction === "asc"
          ? naturalSort(aValue, bValue)
          : naturalSort(bValue, aValue);
      }

      return sortConfig.direction === "asc"
        ? aValue < bValue
          ? -1
          : 1
        : aValue > bValue
        ? -1
        : 1;
    });
  }
  return filteredMachines;
};
